import { CloningStepsEnum, CloningStepsModals } from '../constants'

export const reducerName = 'CLONING_STEPS'

const ActionTypes = {
  SET_CLONING_STEP: 'SET_CLONING_STEP',
  SET_MODAL: 'SET_MODAL',
}

const initialState = {
  step: CloningStepsEnum.BROWSE,
  modal: null,
  outdatedLeagues: [],
}

const CloningStepsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_CLONING_STEP:
      return {
        ...state,
        step: action.step,
      }

    case ActionTypes.SET_MODAL:
      return {
        ...state,
        modal: action.modal,
      }

    default:
      return { ...state }
  }
}

const setCloningStepAction = (cloningStep) => ({
  type: ActionTypes.SET_CLONING_STEP,
  step: cloningStep,
})

export const setCloningStep = (cloningStep) => (dispatch) => {
  dispatch(setCloningStepAction(cloningStep))
}

const setCloningModalAction = (cloningModal) => ({
  type: ActionTypes.SET_MODAL,
  modal: cloningModal,
})

export const setCloningModal = (cloningModal) => (dispatch) => {
  dispatch(setCloningModalAction(cloningModal))
}

export const selectCloningStep = state => state?.[reducerName]?.step
export const selectCloningModal = state => state?.[reducerName]?.modal
export const selectOutdatedLeagues = state => state?.[reducerName]?.outdatedLeagues ?? []

export const namedReducer = { [reducerName]: CloningStepsReducer }

export const getInitialState = (cloneLeaguesSession, { outdatedLeagues = [] } = {}) => {
  const providedStep = cloneLeaguesSession?.data?.cloningStep
  return {
    step: providedStep || CloningStepsEnum.BROWSE,
    outdatedLeagues,
    modal: outdatedLeagues.length > 0 ? CloningStepsModals.OUTDATED_LEAGUES : null,
  }
}
export default CloningStepsReducer
